















































































// vendor
import { defineComponent, ref, computed } from "@vue/composition-api";
// project
import { camelToSentenceCase } from "@/utils/text";

type ResultHandler = (t:string) => any;

import {
	TemplateContext,
	getTemplateContext,
	processTemplate,
} from "../../ts/HTMLTemplates";

export default defineComponent({

	setup(props){

		const value = ref("");
		const fn = ref<ResultHandler|null>(null);
		const show = ref(false);
		const config = ref<string|null>(null);
		const modal = ref(null);

		const editContext = ref<TemplateContext|null>();

		const title = computed(() => {
			if(!editContext.value){ return "Configure Template"; }
			return `Insert: ${editContext.value.template.label}`;
		});

		const variant = computed(() => {
			return "dark";
		});

		const textVariant = computed(() => {
			return ({
				"light":"dark"
			} as any)[variant.value] || "light";
		});

		const canSave = computed(() => {
			return true;
		});

		const confirmText = computed(() => "Confirm");

		const parameters = computed(() => {
			if(!editContext.value){ return []; }
			return editContext.value.template.parameters;
		});

		const getSelectOptions = (options:string[]) => {
			return options.map(o => ({
				value:o,
				text:camelToSentenceCase(o)
			}))
		};

		const ok = () => {
			if(!editContext.value){ return; }
			if(fn.value){ fn.value(processTemplate(editContext.value)); }
			(modal.value as any).hide();
		};

		const hide = () => {
			fn.value = null;
			show.value = false;
			value.value = "";
			config.value = null
			editContext.value = null;
		};

		const open = (templateName:string, f:ResultHandler) => {
			fn.value = f;
			show.value = true;
			editContext.value = getTemplateContext(templateName);
		};

		return {
			title,
			value,
			fn,
			show,
			canSave,
			variant,
			textVariant,
			confirmText,
			modal,
			ok,
			hide,
			open,
			editContext,
			parameters,
			getSelectOptions,
			camelToSentenceCase,
		};
	}
});
